// chart-waarde-woning-schatten.js

import '/src/tailwind.css';

document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', loadChart, { once: true });

    function loadChart() {
        // Load Font Awesome CSS
        const fontAwesomeCSS = document.createElement('link');
        fontAwesomeCSS.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
        fontAwesomeCSS.rel = 'stylesheet';
        document.head.appendChild(fontAwesomeCSS);

        // Load Chart.js script
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/chart.js';
        script.onload = function () {
            const ctx = document.getElementById('priceChart').getContext('2d');
            const priceChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024'],
                    datasets: [
                        {
                            label: 'Huizen met 2 of 3 gevels (€)',
                            data: [161000, 180000, 190000, 195000, 205000, 188000, 225000, 255000, 260000, 259500],
                            borderColor: 'rgba(75, 192, 192, 1)',
                            backgroundColor: 'rgba(75, 192, 192, 0.2)',
                            fill: false,
                        },
                        {
                            label: 'Huizen met 4 of meer gevels (€)',
                            data: [250000, 270000, 275000, 280000, 295000, 289000, 329000, 360000, 369000, 372000],
                            borderColor: 'rgba(153, 102, 255, 1)',
                            backgroundColor: 'rgba(153, 102, 255, 0.2)',
                            fill: false,
                        },
                        {
                            label: 'Appartementen (€)',
                            data: [165750, 170000, 175000, 180000, 185000, 199000, 210000, 225000, 235000, 240125],
                            borderColor: 'rgba(255, 159, 64, 1)',
                            backgroundColor: 'rgba(255, 159, 64, 0.2)',
                            fill: false,
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 10,
                            bottom: 10
                        }
                    },
                    scales: {
                        x: {
                            title: {
                                display: true,
                                text: 'Jaar'
                            }
                        },
                        y: {
                            title: {
                                display: true,
                                text: 'Prijs (in duizendtallen €)'
                            },
                            beginAtZero: false,
                            ticks: {
                                callback: function(value) {
                                    return value / 1000; // Divide values by 1000 to display in thousands
                                }
                            }
                        }
                    }
                }
            });
        };
        document.body.appendChild(script);
    }
});
